'use strict';
var brightcove = brightcove || {};
if (brightcove.createExperiences)
	brightcove.createExperiences();
